// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Odoo_tickets_ReplyInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /odoo_tickets/reply
 *
 * Validates ticket reply requests: requires an existing ticket_id and the
 * reply message body.
 */
import { registerContract } from './validate'

export interface Odoo_tickets_ReplyInput {
ticket_id: number
message: string
}

registerContract('Odoo_tickets_ReplyInput', {
  ticket_id: { type: 'number',  required: true },
  message:   { type: 'string',  required: true },
})
